export const shouldShowMallUnderlinePrice = (showPriceType?: boolean, methodType?: number) => {
    return !!showPriceType && methodType !== 1
}
